import { render, staticRenderFns } from "./AddWebTool.vue?vue&type=template&id=cff9bcf0"
import script from "./AddWebTool.vue?vue&type=script&lang=js"
export * from "./AddWebTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports